import {createSelector} from 'reselect';
import {getSelectedPaymentOptionType} from '../selectors';
import {getOptionalPaymentDetailsConsentConfiguration} from './PaymentOptionSelectors';

const getShouldStorePaymentDetailsForSelectedPaymentOption = createSelector(
  [getOptionalPaymentDetailsConsentConfiguration, getSelectedPaymentOptionType],
  (optionalPaymentDetailsConsentConfiguration, selectedPaymentOptionType) => {
    const shouldStorePaymentDetails = optionalPaymentDetailsConsentConfiguration?.[selectedPaymentOptionType];
    
    if (shouldStorePaymentDetails === true || shouldStorePaymentDetails === false) {
      return shouldStorePaymentDetails;
    }
    
    return null;
  },
);

export default getShouldStorePaymentDetailsForSelectedPaymentOption;
